import domReady from "@wordpress/dom-ready";
import { swiperCreateNew } from "./swiper-settings";
import { typeWriter } from "../../../assets/js/typeWriter";
import { isInViewport } from "../../utils/globalFunctions";

const initSwipers = () => {
	const allSections = document.querySelectorAll(
		".wp-block-theme-blocks-two-columns",
	);
	allSections?.forEach((section) => {
		const thisSwiper = swiperCreateNew(section.id);
	});
};

const initParallax = () => {
	const allParallaxItems = document.querySelectorAll(
		".wp-block-theme-blocks-two-columns .parallax-item",
	);

	allParallaxItems?.forEach((elem) => {
		const paraxElem = elem?.querySelector(".parallax-inner");
		if (paraxElem) {
			window.customScrollbarInstance?.parallaxController?.createElement({
				el: paraxElem,
				props: {
					targetElement: paraxElem,
					translateY: [-25, 25],
				},
			});
		}
	});
};

const initIntersectionObserver = (textItem, section) => {
	const observer = new IntersectionObserver((entries, observer) => {
		entries?.forEach((entry) => {
			if (entry.isIntersecting && entry.intersectionRatio === 1) {
				textItem.classList.add("started");
				const text = textItem.getAttribute("data-text");
				if (text) {
					textItem.removeAttribute("data-text");
					typeWriter(textItem, text)
						.then(() => {
							observer.unobserve(textItem);

							const animatedBlock = section.querySelector(".animated-block");
							const tl = window.customScrollbarInstance?.gsap?.timeline({
								ease: "power2.inOut",
							});

							tl.fromTo(
								animatedBlock.querySelector("h2"),
								{
									y: 25,
									opacity: 0,
								},
								{
									y: 0,
									opacity: 1,
									duration: 0.5,
								},
							);

							tl.fromTo(
								animatedBlock.querySelectorAll("p, a"),
								{
									y: 25,
									opacity: 0,
								},
								{
									y: 0,
									opacity: 1,
									duration: 0.5,
									stagger: 0.1,
								},
							);
						})
						.catch((error) => {
							console.error("An error occurred while typing:", error);
						});
				}
			}
		});
	});

	observer.observe(textItem);
};

const initType = () => {
	const allSections = document.querySelectorAll(
		".wp-block-theme-blocks-two-columns",
	);
	allSections?.forEach((section) => {
		const allTypedTexts = section.querySelectorAll(".typed-text");
		for (const textItem of allTypedTexts) {
			if (
				!textItem.classList.contains("started") &&
				!textItem.classList.contains("finished") &&
				textItem.hasAttribute("data-text")
			) {
				initIntersectionObserver(textItem, section);
			}
		}
	});
};

domReady(() => {
	// console.log("TWO COLUMNS DOM READY");
	initParallax();
	initSwipers();
	initType();
});

window.customScrollbarInstance.scrollbarInstance?.addListener((status) => {
	initType();
});
